var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTempYellow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 44,
    viewBox: "0 0 17 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 29.3794V5.71851C3.78125 3.11255 5.8938 1 8.49976 1V1C11.1057 1 13.2183 3.11255 13.2183 5.71851V29.3794",
    stroke: "#f5a622",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.218 29.3794C14.9188 30.7542 15.9989 32.8575 15.9989 35.2149C15.9989 39.3567 12.6413 42.7143 8.49946 42.7143C4.35762 42.7143 1 39.3567 1 35.2149C1 32.8575 2.0801 30.7542 3.78095 29.3794",
    stroke: "#f5a622",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.83691,
    y: 20.146,
    width: 1.27947,
    height: 14.7284,
    rx: 0.639736,
    fill: "#f5a622",
    stroke: "#f5a622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3078 35.3971C12.3078 37.5003 10.6028 39.2053 8.49961 39.2053C6.3964 39.2053 4.69141 37.5003 4.69141 35.3971C4.69141 33.2939 6.3964 31.5889 8.49961 31.5889C10.6028 31.5889 12.3078 33.2939 12.3078 35.3971Z",
    fill: "#f5a622",
    stroke: "#f5a622"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 28.5356H12.4429",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 21.4236H12.4429",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 14.3118H12.4429",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.209 7.19995L12.4429 7.19995",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 26.7576H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 24.9797H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 23.2017H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 19.6458H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 17.8677H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 16.0898H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 12.5337H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 10.7559H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 8.97778H12.4654",
    stroke: "#f5a622",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTempYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-temp-yellow.e9b32e334fc7f6ad43070a1b0597b76c.svg";